<script setup lang="ts">
import IconHansHeart from '~/components/icons/responsible-gaming/IconHansHeart.vue'
import IconEntertainment from '~/components/icons/responsible-gaming/IconEntertainment.vue'
import IconMedicineHeart from '~/components/icons/responsible-gaming/IconMedicineHeart.vue'

defineOptions({
	name: 'WhySection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="bg-neutral-50 py-11 md:py-20 2xl:py-36">
		<div class="container flex flex-col md:flex-row justify-center gap-10 sm:gap-14 xl:gap-32 min-h-[640px]">
			<div class="flex flex-col gap-10 sm:gap-14 2xl:max-w-[430px] w-full md:w-1/2 2xl:w-full">
				<div class="space-y-5 text-center md:text-left 2xl:pr-2.5">
					<h2 class="text-3xl md:text-[40px] text-secondary-800 font-semibold !leading-tight">
						{{ $t('Why This Page Matters to Us') }}
					</h2>
					<p class="text-neutral-700 leading-6">
						{{
							$t(
								`Our platform is designed to help you discover the potential of your lucky numbers and analyze their past performance, all without any form of betting or financial transactions`,
							)
						}}.
					</p>
				</div>

				<div class="border border-primary-700 rounded-xl p-6 space-y-6 divide-y divide-primary-700/[.12]">
					<div class="flex gap-4">
						<IconHansHeart class="text-primary-700 shrink-0" />

						<div class="space-y-1.5">
							<h3 class="text-primary-700 font-semibold">{{ $t('Promoting Healthy Habits') }}</h3>
							<p class="text-gray-700 text-sm">
								{{ $t('We are committed to fostering safe and responsible playing practices') }}.
							</p>
						</div>
					</div>

					<div class="flex gap-4 pt-6">
						<IconEntertainment class="text-primary-700 shrink-0" />
						<div class="space-y-1.5">
							<h3 class="text-primary-700 font-semibold">{{ $t('Entertainment First and Always') }}</h3>
							<p class="text-gray-700 text-sm">
								{{ $t('Our goal is to ensure that your engagement with luck remains a joyful and positive activity') }}.
							</p>
						</div>
					</div>

					<div class="flex gap-4 pt-6">
						<IconMedicineHeart class="text-primary-700 shrink-0" />
						<div class="space-y-1.5">
							<h3 class="text-primary-700 font-semibold">{{ $t('Your Well-being is Our Priority') }}</h3>
							<p class="text-gray-700 text-sm">
								{{ $t('We strive to keep your pursuit of luck from ever becoming a cause for concern') }}.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="w-full smm:w-1/2 2xl:w-[540px] order-first md:order-last mx-auto md:mx-0">
				<div class="relative w-full min-h-[370px] h-full rounded-3xl overflow-hidden">
					<NuxtImg
						src="/cdn/user_responsible_gaming.webp"
						width="1080"
						format="webp"
						quality="85"
						class="absolute inset-0 w-full h-full object-cover object-center"
						alt="User use phone"
					/>
				</div>
			</div>
		</div>
	</section>
</template>
